import { jsx as _jsx } from "react/jsx-runtime";
import { cdnClient } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { useI18n } from '../../context/occ/hooks/use-i18n';
import { Image } from '../image/image';
const b = bemClassBuilder('v-censor-rating-icon');
export const CensorRatingIcon = observer(props => {
    const i18n = useI18n();
    const { censorRating, className, cdnOptions } = props;
    const [isValidURL, setIsValidURL] = useState(true);
    const classification = i18n.translatable(censorRating.classification);
    const classModifier = classification.replace(/[^0-9a-z]/gi, '');
    const onError = () => {
        setIsValidURL(false);
    };
    return (_jsx("span", Object.assign({ className: b.block(undefined, className) }, { children: isValidURL ? (_jsx(Image, { onError: onError, className: b.element('img'), src: cdnClient.instance.censorRating(censorRating.id).icon(cdnOptions), alt: classification })) : (_jsx("span", Object.assign({ className: b.element('classification', { [classModifier]: true }) }, { children: classification }))) })));
});
CensorRatingIcon.displayName = 'CensorRatingIcon';
